/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../TrueGrit";

export class TrueGritIdleNormalPresentation implements FlowStatePresentation {

    private _presentations:SimplePresentation[];
    private _flowStateController:FlowStateController;

    constructor() {
        this._presentations = []
    }

    public start(flowStateController:FlowStateController) {
        // Check to show FS/SUPER FS outro
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?:Function) => flowStateController.setSkipCallback(callback));
    }

    public complete() {
        this._flowStateController.finish();
    }
}